/* ============================================================
   Afscheidsvideo.nl — Bestelspoor (wizard) controller
   Eén centraal bestand dat de stappen toont/verbergt, state bewaart
   in sessionStorage (refresh-veilig) en de API/cart-koppeling regelt.
   Specificatie: BESTELSPOOR.md
   Stap-specifieke logica wordt blok voor blok toegevoegd.
   ============================================================ */
(function () {
  'use strict';

  var STATE_KEY = 'av_wizard_state_v1';
  var RESUME_KEY = 'av_wizard_resume_v1'; // demo_id + email t.b.v. resume

  var root = document.querySelector('[data-av-wizard]');
  if (!root) return;

  // ── Configuratie uit de host-sectie ───────────────────────────
  var config = {
    apiBase: (root.dataset.apiBase || '').replace(/\/$/, ''),
    variants: {
      digitaal: root.dataset.variantDigitaal,
      compleet: root.dataset.variantCompleet,
      familie: root.dataset.variantFamilie,
      usb: root.dataset.variantUsb
    },
    usbPrice: root.dataset.usbPrice || '€19,95',
    termsUrl: root.dataset.termsUrl || '/policies/terms-of-service',
    testDemoId: root.dataset.testDemoId || ''
  };

  // ── Stappen in DOM-volgorde ───────────────────────────────────
  var stepEls = Array.prototype.slice.call(root.querySelectorAll('[data-wizard-step]'));
  var stepKeys = stepEls.map(function (el) { return el.dataset.wizardStep; });
  var total = stepEls.length;

  // ── State ─────────────────────────────────────────────────────
  var defaultState = {
    currentStep: 0,
    recipients: [{ name: '', phonetic: '' }],
    occasion: 'Afscheid',
    moodKey: '',
    mood: '',
    extra_wishes: '',
    voice_type: '',
    musicStyle: 'rustig akoestisch',
    story: '',
    useOwnLyrics: false,
    ownLyrics: '',
    songtext: '',
    email: '',
    demo_id: '',
    task_id: '',
    song_index: null,
    package: '',
    usbCount: 0,
    termsAccepted: false,
    video_thema: 'normaal'
  };

  var state = loadState();

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STATE_KEY);
      if (raw) return Object.assign({}, defaultState, JSON.parse(raw));
    } catch (e) { /* sessionStorage geblokkeerd of corrupt */ }
    return Object.assign({}, defaultState);
  }

  function saveState() {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function setState(patch) {
    Object.assign(state, patch);
    saveState();
  }

  // demo_id + e-mail apart bewaren voor de resume-flow
  function saveResume() {
    if (!state.demo_id) return;
    try {
      localStorage.setItem(RESUME_KEY, JSON.stringify({ demo_id: state.demo_id, email: state.email }));
    } catch (e) {}
  }

  // ── Per-stap handlers (worden later gevuld) ───────────────────
  // handlers[key] = { onEnter: fn(ctx), validate: fn() -> true|string }
  var handlers = {};

  // ── Navigatie ─────────────────────────────────────────────────
  var index = clampIndex(state.currentStep);

  function clampIndex(i) {
    i = parseInt(i, 10);
    if (isNaN(i) || i < 0) return 0;
    if (i > total - 1) return total - 1;
    return i;
  }

  function announce(msg) {
    var live = root.querySelector('[data-wizard-live]');
    if (live) live.textContent = msg;
  }

  function setStepError(el, msg) {
    var e = el && el.querySelector('[data-step-error]');
    if (e) { e.textContent = msg; e.hidden = false; }
  }

  function clearStepError(el) {
    var e = el && el.querySelector('[data-step-error]');
    if (e) { e.textContent = ''; e.hidden = true; }
  }

  function showStep(i, opts) {
    opts = opts || {};
    var target = clampIndex(i);
    if (target !== index) {
      var prevKey = stepKeys[index];
      if (handlers[prevKey] && typeof handlers[prevKey].onLeave === 'function') {
        try { handlers[prevKey].onLeave(); } catch (e) { console.error('[wizard] onLeave', prevKey, e); }
      }
    }
    index = target;
    stepEls.forEach(function (el, n) {
      var active = n === index;
      el.hidden = !active;
      el.classList.toggle('is-active', active);
    });
    setState({ currentStep: index });
    updateProgress();

    var restart = root.querySelector('[data-wizard-restart]');
    if (restart) restart.hidden = index === 0; // niet op stap 1

    var key = stepKeys[index];
    var el = stepEls[index];
    clearStepError(el);
    if (handlers[key] && typeof handlers[key].onEnter === 'function') {
      try { handlers[key].onEnter(ctx, el); } catch (e) { console.error('[wizard] onEnter', key, e); }
    }

    announce('Stap ' + (index + 1) + ' van ' + total);
    if (!opts.silent) {
      // Breng de bovenkant van de wizard in beeld (vaste header-offset)
      var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top > 0 ? top : 0, behavior: 'smooth' });
      var focusable = el.querySelector('h2, [autofocus], input, textarea, button');
      if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
    }
  }

  function updateProgress() {
    var fill = root.querySelector('[data-wizard-progress-fill]');
    var stepLabel = root.querySelector('[data-wizard-progress-step]');
    var titleLabel = root.querySelector('[data-wizard-progress-title]');
    var pct = total > 1 ? ((index + 1) / total) * 100 : 100;
    if (fill) fill.style.width = pct.toFixed(1) + '%';
    if (stepLabel) stepLabel.textContent = 'Stap ' + (index + 1) + ' van ' + total;
    if (titleLabel) titleLabel.textContent = stepEls[index].dataset.stepTitle || '';
  }

  function next() {
    var key = stepKeys[index];
    if (handlers[key] && typeof handlers[key].validate === 'function') {
      var result = handlers[key].validate();
      if (result !== true) {
        var msg = typeof result === 'string' ? result : 'Vul dit in om verder te gaan.';
        setStepError(stepEls[index], msg);
        announce(msg);
        return; // validatie faalt → niet doorgaan
      }
    }
    clearStepError(stepEls[index]);
    if (index < total - 1) showStep(index + 1);
  }

  function back() {
    if (index > 0) showStep(index - 1);
  }

  function goToKey(key, opts) {
    var i = stepKeys.indexOf(key);
    if (i >= 0) showStep(i, opts);
  }

  // Volledige reset: sessionStorage + in-memory state wissen, terug naar stap 1.
  // localStorage (resume: demo_id + e-mail) blijft staan, zodat een eerdere
  // demo hervatbaar blijft via de resume-link.
  function resetWizard() {
    try { sessionStorage.removeItem(STATE_KEY); } catch (e) {}
    window.location.replace(location.pathname); // schoon herladen op stap 1
  }

  // Klikafhandeling via delegatie
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wizard-next], [data-wizard-back], [data-wizard-checkout], [data-wizard-restart]');
    if (!t) return;
    if (t.hasAttribute('data-wizard-next')) { e.preventDefault(); next(); }
    else if (t.hasAttribute('data-wizard-back')) { e.preventDefault(); back(); }
    else if (t.hasAttribute('data-wizard-checkout')) { e.preventDefault(); checkout(); }
    else if (t.hasAttribute('data-wizard-restart')) {
      e.preventDefault();
      if (window.confirm('Weet je het zeker? Je huidige voortgang gaat verloren.')) resetWizard();
    }
  });

  // ── API-helpers (voor latere stappen) ─────────────────────────
  function api(path, options) {
    options = options || {};
    var url = config.apiBase + path;
    var init = { method: options.method || 'GET', headers: {} };
    if (options.body != null) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(options.body);
    }
    return fetch(url, init).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function previewUrl(demoId, songIndex) {
    return config.apiBase + '/demo-preview?demo_id=' + encodeURIComponent(demoId) +
      '&song_index=' + (songIndex === 1 ? 1 : 0);
  }

  // Eén bron voor de spelers: directe URL (bv. uit resume) als die er is,
  // anders de demo-preview-URL op basis van demo_id. Zo speelt elke flow.
  function songSrc(songIndex) {
    var direct = (state.audioUrls || [])[songIndex];
    if (direct) return direct;
    var demoId = state.demo_id || config.testDemoId;
    return demoId ? previewUrl(demoId, songIndex) : '';
  }

  // Poll demo-status.
  // Opties via cbs: initialDelay (wachten vóór de eerste poll), interval,
  //   graceMs (periode waarin not_found/HTTP-fouten worden getolereerd),
  //   maxMs (veiligheidsmarge; 0 = geen limiet).
  // Callbacks: onUpdate(data), onDone(data), onFail(reason, err), onTimeout().
  function pollDemo(demoId, cbs) {
    cbs = cbs || {};
    var interval = cbs.interval || 5000;
    var initialDelay = cbs.initialDelay || 0;
    var graceMs = cbs.graceMs || 0;
    var maxMs = cbs.maxMs || 0;
    var stopped = false;
    var started = Date.now();
    function elapsed() { return Date.now() - started; }

    function tick() {
      if (stopped) return;
      api('/demo-poll?demo_id=' + encodeURIComponent(demoId))
        .then(function (data) {
          if (stopped) return;
          if (cbs.onUpdate) cbs.onUpdate(data);
          var status = data && data.status;
          if (status === 'completed') { if (cbs.onDone) cbs.onDone(data); return; }
          if (status === 'failed') { if (cbs.onFail) cbs.onFail('failed', data); return; }
          // not_found / leeg / processing → gewoon doorpollen
          if (maxMs && elapsed() >= maxMs) { if (cbs.onTimeout) cbs.onTimeout(); return; }
          setTimeout(tick, interval);
        })
        .catch(function (err) {
          if (stopped) return;
          // Vroege HTTP-fout (bv. 404: demo nog niet in de database) → binnen de grace tolereren.
          if (elapsed() < graceMs) { setTimeout(tick, interval); return; }
          if (maxMs && elapsed() >= maxMs) { if (cbs.onTimeout) cbs.onTimeout(); return; }
          if (cbs.onFail) cbs.onFail('network', err);
        });
    }

    if (initialDelay > 0) setTimeout(tick, initialDelay); else tick();
    return function stop() { stopped = true; };
  }

  // ── Cart & checkout (stap 11) ─────────────────────────────────
  function checkout() {
    if (!state.package) { announce('Kies eerst een pakket.'); goToKey('package'); return; }
    if (!(state.song_index === 0 || state.song_index === 1)) { announce('Kies eerst een versie van het lied.'); goToKey('player'); return; }
    if (!state.termsAccepted) { announce('Ga eerst akkoord met de algemene voorwaarden.'); return; }
    var variantId = config.variants[state.package];
    if (!variantId) { announce('Onbekend pakket. Probeer het opnieuw.'); return; }

    var btn = root.querySelector('[data-wizard-checkout]');
    var summaryEl = root.querySelector('[data-wizard-step="summary"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig…'; }
    clearStepError(summaryEl);

    function fail(reason) {
      if (summaryEl) setStepError(summaryEl, reason);
      announce(reason);
      if (btn) { btn.disabled = false; btn.textContent = 'Naar betalen'; }
    }

    // Variant-id's als NUMBER (geen string) — anders 422.
    var pkgId = Number(variantId);
    var usbId = Number(config.variants.usb);

    // Demo-koppeling alléén op het pakket-item (niet op het USB-item).
    var items = [{
      id: pkgId,
      quantity: 1,
      properties: {
        '_demo_id': String(state.demo_id || ''),
        '_song_index': String(state.song_index),
        '_package_type': String(state.package),
        '_video_thema': String(state.video_thema || 'normaal'),
        'Voor wie': String(state.recipient || '')
      }
    }];
    if (state.usbCount > 0 && usbId) {
      items.push({ id: usbId, quantity: state.usbCount });
    }

    var payload = { items: items };
    // Log de exacte body zodat we variant-id's + structuur kunnen verifiëren.
    console.log('[wizard] cart/add.js body →', JSON.stringify(payload));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) { window.location.href = '/checkout'; return; }
      // Lees de Shopify-foutbody uit (bevat 'description' + 'message' met de reden).
      return res.json().then(function (err) {
        console.error('[wizard] cart/add.js ' + res.status + ' →', err);
        var reason = (err && (err.description || err.message)) || ('Afrekenen mislukte (status ' + res.status + ').');
        fail('Afrekenen lukte niet: ' + reason);
      }).catch(function () {
        console.error('[wizard] cart/add.js ' + res.status + ' (geen leesbare body)');
        fail('Afrekenen mislukte (status ' + res.status + ').');
      });
    }).catch(function (e) {
      console.error('[wizard] cart/add.js netwerkfout →', e);
      fail('Er ging iets mis bij het afrekenen. Probeer het opnieuw.');
    });
  }

  // ── Context voor stap-handlers ────────────────────────────────
  var ctx = {
    config: config,
    state: state,
    setState: setState,
    saveResume: saveResume,
    api: api,
    previewUrl: previewUrl,
    pollDemo: pollDemo,
    goToKey: goToKey,
    next: next,
    back: back,
    announce: announce,
    register: function (key, handler) { handlers[key] = handler; }
  };

  // Beschikbaar voor latere stap-modules / debugging
  window.AvWizard = ctx;

  // ══ Stappen 1–5 — invoer ══════════════════════════════════════
  (function registerInputSteps() {
    var MOOD_MAP = {
      ingetogen: 'ingetogen en warm',
      hoopvol: 'hoopvol en licht',
      klassiek: 'klassiek en plechtig',
      persoonlijk: 'persoonlijk en intiem'
    };

    // ── Stap 1 — Voor wie ──
    var recipientStep = root.querySelector('[data-wizard-step="recipient"]');
    var listEl = recipientStep && recipientStep.querySelector('[data-recipient-list]');
    var tmpl = recipientStep && recipientStep.querySelector('[data-recipient-template]');

    function addRecipientRow(data) {
      if (!listEl || !tmpl) return;
      var node = tmpl.content.firstElementChild.cloneNode(true);
      if (data) {
        node.querySelector('[data-recipient-name]').value = data.name || '';
        if (data.phonetic) {
          node.querySelector('[data-recipient-phonetic]').value = data.phonetic;
          node.querySelector('[data-phonetic]').hidden = false;
          node.querySelector('[data-toggle-phonetic]').checked = true;
        }
      }
      listEl.appendChild(node);
      refreshRemoveButtons();
    }
    function refreshRemoveButtons() {
      var rows = listEl.querySelectorAll('[data-recipient-row]');
      rows.forEach(function (r) {
        var b = r.querySelector('[data-remove-recipient]');
        if (b) b.hidden = rows.length <= 1;
      });
    }
    function syncRecipients() {
      var rows = listEl.querySelectorAll('[data-recipient-row]');
      var arr = [];
      rows.forEach(function (r) {
        var nm = (r.querySelector('[data-recipient-name]').value || '').trim();
        var cb = r.querySelector('[data-toggle-phonetic]');
        var pe = r.querySelector('[data-recipient-phonetic]');
        var ph = (cb && cb.checked && pe) ? (pe.value || '').trim() : '';
        arr.push({ name: nm, phonetic: ph });
      });
      if (!arr.length) arr = [{ name: '', phonetic: '' }];
      setState({ recipients: arr, recipient: arr[0].name });
    }

    if (recipientStep) {
      recipientStep.addEventListener('click', function (e) {
        if (e.target.closest('[data-add-recipient]')) { e.preventDefault(); addRecipientRow(); }
        else if (e.target.closest('[data-remove-recipient]')) {
          e.preventDefault();
          var row = e.target.closest('[data-recipient-row]');
          if (row) { row.remove(); refreshRemoveButtons(); syncRecipients(); }
        }
      });
      recipientStep.addEventListener('change', function (e) {
        var cb = e.target.closest('[data-toggle-phonetic]');
        if (!cb) return;
        var row = cb.closest('[data-recipient-row]');
        var wrap = row.querySelector('[data-phonetic]');
        var pin = row.querySelector('[data-recipient-phonetic]');
        var nin = row.querySelector('[data-recipient-name]');
        if (cb.checked) {
          if (wrap) wrap.hidden = false;
          if (pin && !pin.value.trim() && nin) pin.value = nin.value; // automatisch voorvullen met de naam
          if (pin) pin.focus();
        } else if (wrap) {
          wrap.hidden = true;
        }
        syncRecipients();
      });
      recipientStep.addEventListener('input', function (e) {
        if (e.target.matches('[data-recipient-name], [data-recipient-phonetic]')) syncRecipients();
      });
    }

    handlers.recipient = {
      onEnter: function () {
        if (!listEl) return;
        if (!listEl.children.length) {
          var rs = (state.recipients && state.recipients.length) ? state.recipients : [{ name: '', phonetic: '' }];
          rs.forEach(function (r) { addRecipientRow(r); });
          if (!listEl.children.length) addRecipientRow();
        }
        refreshRemoveButtons();
      },
      validate: function () {
        syncRecipients();
        var filled = state.recipients.filter(function (r) { return r.name && r.name.length >= 2; });
        if (!filled.length) return 'Vul ten minste één naam in (minstens 2 tekens).';
        setState({ recipients: filled, recipient: filled[0].name });
        return true;
      }
    };

    // ── Stap 2 — Sfeer ──
    var moodStep = root.querySelector('[data-wizard-step="mood"]');
    if (moodStep) {
      moodStep.addEventListener('change', function (e) {
        if (e.target.matches('[data-mood-radio]')) {
          setState({ moodKey: e.target.value, mood: MOOD_MAP[e.target.value] || e.target.value });
        } else if (e.target.matches('[data-voice]')) {
          setState({ voice_type: e.target.value });
        }
      });
      moodStep.addEventListener('input', function (e) {
        if (e.target.matches('[data-mood-extra]')) setState({ extra_wishes: e.target.value.trim() });
      });
    }
    handlers.mood = {
      onEnter: function () {
        if (state.moodKey) {
          var r = moodStep.querySelector('[data-mood-radio][value="' + state.moodKey + '"]');
          if (r) r.checked = true;
        }
        var ex = moodStep.querySelector('[data-mood-extra]');
        if (ex) ex.value = state.extra_wishes || '';
        var v = moodStep.querySelector('[data-voice][value="' + (state.voice_type || '') + '"]');
        if (v) v.checked = true;
      },
      validate: function () {
        if (state.moodKey || (state.extra_wishes && state.extra_wishes.length)) return true;
        return 'Kies een sfeer of beschrijf er zelf één.';
      }
    };

    // ── Stap 3 — Verhaal ──
    var storyStep = root.querySelector('[data-wizard-step="story"]');
    function applyOwnState(on) {
      if (!storyStep) return;
      var ownWrap = storyStep.querySelector('[data-own-wrap]');
      var storyWrap = storyStep.querySelector('[data-story-wrap]');
      var storyTa = storyStep.querySelector('[data-story]');
      if (ownWrap) ownWrap.hidden = !on;
      if (storyWrap) storyWrap.classList.toggle('is-disabled', on);
      if (storyTa) storyTa.disabled = on; // greyed out + niet bewerkbaar
    }
    if (storyStep) {
      storyStep.addEventListener('input', function (e) {
        if (e.target.matches('[data-story]')) setState({ story: e.target.value });
        else if (e.target.matches('[data-own-lyrics]')) setState({ ownLyrics: e.target.value });
      });
      storyStep.addEventListener('change', function (e) {
        if (e.target.matches('[data-own-toggle]')) {
          setState({ useOwnLyrics: e.target.checked });
          applyOwnState(e.target.checked);
        }
      });
    }
    handlers.story = {
      onEnter: function () {
        var s = storyStep.querySelector('[data-story]'); if (s) s.value = state.story || '';
        var ot = storyStep.querySelector('[data-own-toggle]'); if (ot) ot.checked = !!state.useOwnLyrics;
        var ol = storyStep.querySelector('[data-own-lyrics]'); if (ol) ol.value = state.ownLyrics || '';
        applyOwnState(!!state.useOwnLyrics);
      },
      validate: function () {
        if (state.useOwnLyrics) {
          var ol = (state.ownLyrics || '').trim();
          if (ol.length < 10) return 'Plak je eigen songtekst (minstens 10 tekens).';
          if (ol.length > 4000) return 'De tekst is te lang (max 4000 tekens).';
          return true;
        }
        if ((state.story || '').trim().length < 10) return 'Vertel iets meer (minstens 10 tekens).';
        return true;
      }
    };

    // ── Stap 4 — Songtekst ──
    var lyricsStep = root.querySelector('[data-wizard-step="lyrics"]');
    function lyShow(which) {
      ['loading', 'error', 'result'].forEach(function (k) {
        var el = lyricsStep.querySelector('[data-lyrics-' + k + ']');
        if (el) el.hidden = (k !== which);
      });
    }
    function renderLyrics(text) {
      var t = lyricsStep.querySelector('[data-lyrics-text]');
      if (!t) return;
      if ('value' in t) t.value = text || '';
      else t.textContent = text || '';
    }
    // opts: { feedback, original }
    //  - frisse generatie  → roep aan zonder original (en zonder feedback)
    //  - revisie           → original = huidige tekst + feedback
    function callLyrics(opts) {
      opts = opts || {};
      var isRevise = !!opts.original;
      var loadingText = lyricsStep.querySelector('[data-lyrics-loading-text]');
      if (loadingText) loadingText.textContent = isRevise
        ? 'We passen de songtekst aan…'
        : 'We schrijven een songtekst op basis van jouw verhaal…';
      lyShow('loading');
      var body = {
        recipients: (state.recipients || []).filter(function (r) { return r.name; }),
        occasion: state.occasion || 'Afscheid',
        story: state.story || '',
        mood: state.mood || 'ingetogen en warm',
        musicStyle: state.musicStyle || 'rustig akoestisch',
        voiceType: state.voice_type || ''
      };
      // Alleen bij revisie: de bestaande tekst + feedback meesturen.
      if (isRevise) {
        body.originalLyrics = opts.original;
        if (opts.feedback) body.feedback = opts.feedback;
      }
      api('/lyrics-generate', { method: 'POST', body: body }).then(function (res) {
        if (res && res.songtext) {
          setState({ _lyricsDraft: res.songtext });
          renderLyrics(res.songtext);
          lyShow('result');
          announce(isRevise ? 'De tekst is aangepast.' : 'Er is een nieuwe tekst gegenereerd.');
        } else { throw new Error('geen songtext'); }
      }).catch(function () {
        var e = lyricsStep.querySelector('[data-lyrics-error]');
        if (e) e.innerHTML = 'Het lukte niet om de songtekst te genereren. <button type="button" class="av-wiz__link" data-lyrics-retry>Opnieuw proberen</button>';
        lyShow('error');
      });
    }
    if (lyricsStep) {
      lyricsStep.addEventListener('click', function (e) {
        if (e.target.closest('[data-lyrics-approve]')) {
          e.preventDefault();
          var text = state.useOwnLyrics ? (state.ownLyrics || '') : (state._lyricsDraft || '');
          setState({ songtext: text });
          next();
        } else if (e.target.closest('[data-lyrics-revise]')) {
          e.preventDefault();
          var fbEl = lyricsStep.querySelector('[data-lyrics-feedback]');
          var fb = fbEl ? fbEl.value.trim() : '';
          if (!fb) { announce('Beschrijf eerst wat je wilt aanpassen.'); if (fbEl) fbEl.focus(); return; }
          callLyrics({ feedback: fb, original: state._lyricsDraft || '' });
        } else if (e.target.closest('[data-lyrics-regenerate]')) {
          e.preventDefault();
          var fbClear = lyricsStep.querySelector('[data-lyrics-feedback]');
          if (fbClear) fbClear.value = '';
          callLyrics({}); // frisse nieuwe tekst, GEEN originalLyrics
        } else if (e.target.closest('[data-lyrics-retry]')) {
          e.preventDefault();
          callLyrics({});
        }
      });
      // Eigen aanpassingen in het songtekstveld direct bewaren
      lyricsStep.addEventListener('input', function (e) {
        if (e.target.matches('[data-lyrics-text]')) {
          if (state.useOwnLyrics) setState({ ownLyrics: e.target.value });
          else setState({ _lyricsDraft: e.target.value });
        }
      });
    }
    handlers.lyrics = {
      onEnter: function () {
        var intro = lyricsStep.querySelector('[data-lyrics-intro]');
        var fw = lyricsStep.querySelector('[data-lyrics-feedback-wrap]');
        var rg = lyricsStep.querySelector('[data-lyrics-regenerate]');
        var rv = lyricsStep.querySelector('[data-lyrics-revise]');
        if (state.useOwnLyrics) {
          if (intro) intro.textContent = 'Dit is je eigen tekst — je kunt hem hier direct aanpassen. Klopt het? Dan ga je verder.';
          if (fw) fw.hidden = true;
          if (rg) rg.hidden = true;
          if (rv) rv.hidden = true;
          renderLyrics(state.ownLyrics || '');
          lyShow('result');
          return;
        }
        if (intro) intro.textContent = 'Lees de tekst rustig door en pas hem gerust zelf aan. Klopt het? Dan ga je verder.';
        if (fw) fw.hidden = false;
        if (rg) rg.hidden = false;
        if (rv) rv.hidden = false;
        if (state._lyricsDraft) { renderLyrics(state._lyricsDraft); lyShow('result'); }
        else callLyrics({});
      }
    };

    // ── Stap 5 — E-mail ──
    var emailStep = root.querySelector('[data-wizard-step="email"]');
    if (emailStep) {
      emailStep.addEventListener('input', function (e) {
        if (e.target.matches('[data-email]')) setState({ email: e.target.value.trim() });
      });
    }
    handlers.email = {
      onEnter: function () {
        var i = emailStep.querySelector('[data-email]');
        if (i) i.value = state.email || '';
      },
      validate: function () {
        var v = (state.email || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Vul een geldig e-mailadres in.';
        if (/@example\./i.test(v)) return 'Gebruik je eigen e-mailadres.';
        return true;
      }
    };
  })();

  // ══ Stap 6 — Demo genereren + polling ═════════════════════════
  (function registerGenerating() {
    var genEl = root.querySelector('[data-wizard-step="generating"]');
    if (!genEl) return;

    var genStatus = 'idle'; // idle | generating | polling | done | failed
    var stopCurrentPoll = null;

    function show(which) {
      var l = genEl.querySelector('[data-gen-loading]');
      var e = genEl.querySelector('[data-gen-error]');
      if (l) l.hidden = which !== 'loading';
      if (e) e.hidden = which !== 'error';
    }
    function setStatus(msg) {
      var s = genEl.querySelector('[data-gen-status]');
      if (s) s.textContent = msg || '';
    }
    // kind: 'fail' (→ Opnieuw proberen) of 'timeout' (→ Blijf wachten)
    function showError(msg, kind) {
      var t = genEl.querySelector('[data-gen-error-text]');
      if (t) t.textContent = msg;
      var retry = genEl.querySelector('[data-gen-retry]');
      var wait = genEl.querySelector('[data-gen-wait]');
      if (retry) retry.hidden = kind === 'timeout';
      if (wait) wait.hidden = kind !== 'timeout';
      show('error');
    }

    // Handtekening van de invoer: bij gelijke invoer hergebruiken we de demo,
    // bij gewijzigde invoer maken we een nieuwe (voorkomt verspilde credits).
    function currentSig() {
      return JSON.stringify({
        email: state.email,
        songtext: state.songtext,
        mood: state.mood,
        voice: state.voice_type,
        extra: state.extra_wishes,
        names: (state.recipients || []).map(function (r) { return r.name + '|' + (r.phonetic || ''); })
      });
    }

    function ready(data) {
      if (genStatus === 'done') return; // niet dubbel doorgaan
      genStatus = 'done';
      if (stopCurrentPoll) stopCurrentPoll();
      setState({ demoCompleted: !!(data && data.status === 'completed') });
      setStatus('Klaar!');
      goToKey('player'); // direct luisteren, ook al is de volledige versie nog bezig
    }
    // delay = ms wachten vóór de eerste poll (na een verse generate moet de
    // demo eerst in de database belanden).
    function startPoll(demoId, delay) {
      if (stopCurrentPoll) stopCurrentPoll();
      delay = delay || 0;
      genStatus = 'polling';
      show('loading');
      setStatus(delay ? 'We bereiden de compositie voor…' : 'De compositie is bezig…');
      stopCurrentPoll = pollDemo(demoId, {
        initialDelay: delay,
        interval: 5000,
        graceMs: delay + 30000, // ~30s na de eerste poll mag de demo nog "not_found" zijn
        maxMs: 240000,          // veiligheidsmarge: 4 minuten
        onUpdate: function (data) {
          // Zodra de stream-versie klaar is (has_songs) meteen door — niet wachten op "completed".
          if (data && data.has_songs) { ready(data); return; }
          if (data && data.status === 'processing') setStatus('De compositie is bezig…');
        },
        onDone: function (data) { ready(data); }, // status "completed" als fallback
        onFail: function (reason) {
          genStatus = 'failed';
          showError(reason === 'failed'
            ? 'De compositie is helaas niet gelukt. Probeer het opnieuw.'
            : 'We konden de status niet ophalen. Controleer je verbinding en probeer opnieuw.', 'fail');
        },
        onTimeout: function () {
          genStatus = 'idle';
          showError('Het duurt langer dan verwacht. We sturen je de demo per e-mail zodra die klaar is.', 'timeout');
        }
      });
    }

    function startDemo(sig) {
      genStatus = 'generating';
      show('loading');
      setStatus('We starten de compositie…');
      var names = (state.recipients || []).filter(function (r) { return r.name; })
        .map(function (r) { return { name: r.name, phonetic: r.phonetic || '' }; });
      var body = {
        _cfg: 'v2',
        email: state.email || '',
        names: names,
        recipient: state.recipient || (names[0] && names[0].name) || '',
        occasion: state.occasion || 'Afscheid',
        songtext: state.songtext || '',
        story: state.story || '',
        musicStyle: state.musicStyle || 'rustig akoestisch',
        mood: state.mood || 'ingetogen en warm',
        voice_type: state.voice_type || '',
        extra_wishes: state.extra_wishes || ''
      };
      api('/demo-generate', { method: 'POST', body: body }).then(function (res) {
        if (res && res.success && res.demo_id) {
          setState({ demo_id: res.demo_id, task_id: res.task_id || '', _demoSig: sig, song_index: null, _resumed: false, audioUrls: [] });
          saveResume(); // demo_id + e-mail in localStorage
          startPoll(res.demo_id, 6000); // wacht ~6s zodat de demo in de database staat
        } else {
          throw new Error('geen demo_id');
        }
      }).catch(function () {
        genStatus = 'failed';
        showError('Het lukte niet om de demo te starten. Probeer het opnieuw.', 'fail');
      });
    }

    if (genEl) {
      genEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-gen-retry]')) {
          e.preventDefault();
          genStatus = 'idle';
          startDemo(currentSig());
        } else if (e.target.closest('[data-gen-wait]')) {
          e.preventDefault();
          genStatus = 'idle';
          if (state.demo_id) startPoll(state.demo_id, 0); // blijf pollen op de bestaande demo
          else startDemo(currentSig());
        }
      });
    }

    handlers.generating = {
      onEnter: function () {
        var sig = currentSig();
        // Bestaande demo (zelfde invoer óf hervatte sessie)? Dan hergebruiken.
        if (state.demo_id && (state._demoSig === sig || state._resumed)) {
          if (genStatus === 'done') { goToKey('player'); return; }
          startPoll(state.demo_id, 0); // bestaande demo → meteen pollen, geen wachttijd
          return;
        }
        startDemo(sig); // nieuwe of gewijzigde invoer → nieuwe demo
      },
      onLeave: function () {
        if (stopCurrentPoll) stopCurrentPoll();
        if (genStatus === 'polling') genStatus = 'idle'; // hervat netjes bij terugkomst
      }
    };
  })();

  // ══ Stap 7 — Demo-speler ══════════════════════════════════════
  (function registerPlayer() {
    var playerEl = root.querySelector('[data-wizard-step="player"]');
    if (!playerEl) return;

    function playerNextBtn() { return playerEl.querySelector('[data-wizard-next]'); }

    function markChosen(idx) {
      playerEl.querySelectorAll('[data-player-card]').forEach(function (card) {
        card.classList.toggle('is-chosen', card.getAttribute('data-player-card') === String(idx));
      });
    }

    function updateNextEnabled() {
      var btn = playerNextBtn();
      if (btn) btn.disabled = !(state.song_index === 0 || state.song_index === 1);
    }

    // Eén speler tegelijk: pauzeer de andere bij afspelen (eenmalig bedraden)
    var wired = false;
    function wireSinglePlayback() {
      if (wired) return;
      wired = true;
      var audios = playerEl.querySelectorAll('[data-audio]');
      audios.forEach(function (a) {
        a.addEventListener('play', function () {
          audios.forEach(function (other) { if (other !== a) other.pause(); });
        });
      });
    }

    // Subtiele "processing"-hint: zichtbaar tot de volledige versie klaar is.
    var hintStop = null;
    function manageHint(demoId) {
      var hint = playerEl.querySelector('[data-player-hint]');
      if (!hint) return;
      if (hintStop) { hintStop(); hintStop = null; }
      // Alleen bij een echte (lopende) demo; test-demo en voltooide demo: geen hint.
      if (!state.demo_id || state.demoCompleted) { hint.hidden = true; return; }
      hint.hidden = false;
      hintStop = pollDemo(demoId, {
        onDone: function () {
          setState({ demoCompleted: true });
          hint.hidden = true;
          if (hintStop) { hintStop(); hintStop = null; }
        },
        onFail: function () { /* speler werkt al; hint mag blijven staan */ }
      });
    }

    // ── Uitspraakcorrectie (cover) per versie ──
    var coverPending = false;
    var coverStop = null;

    function setBusy(on) {
      var main = playerEl.querySelector('[data-player-main]');
      var busy = playerEl.querySelector('[data-player-busy]');
      var nav = playerEl.querySelector('[data-player-nav]');
      if (main) main.hidden = on;
      if (busy) busy.hidden = !on;
      if (nav) nav.hidden = on;
    }
    function refreshAudio(demoId) {
      var a0 = playerEl.querySelector('[data-audio="0"]');
      var a1 = playerEl.querySelector('[data-audio="1"]');
      // src vervangen én .load() zodat het element de nieuwe bron echt oppikt (niet de oude buffer).
      if (a0) { a0.src = songSrc(0); a0.load(); }
      if (a1) { a1.src = songSrc(1); a1.load(); }
    }
    function clearChoice() {
      playerEl.querySelectorAll('[data-song-radio]').forEach(function (r) { r.checked = false; });
      markChosen(-1);
      updateNextEnabled();
    }
    // Hulplink naar contact, met demo-code + e-mail voorgevuld in de URL
    function updateHelpLink() {
      var h = playerEl.querySelector('[data-player-help]');
      if (!h) return;
      var qs = [];
      if (state.demo_id) qs.push('demo_id=' + encodeURIComponent(state.demo_id));
      if (state.email) qs.push('email=' + encodeURIComponent(state.email));
      h.href = '/pages/contact' + (qs.length ? '?' + qs.join('&') : '');
    }
    function coverReady(demoId, data) {
      if (!coverPending) return;
      coverPending = false;
      if (coverStop) { coverStop(); coverStop = null; }
      setState({ demoCompleted: !!(data && data.status === 'completed'), song_index: null });
      refreshAudio(demoId);
      // Getoonde demo-code verversen naar het nieuwe id (scherm werd anders niet bijgewerkt).
      var dcv = playerEl.querySelector('[data-player-democode-value]');
      if (dcv) dcv.textContent = state.demo_id || demoId || '';
      updateHelpLink();
      clearChoice();
      playerEl.querySelectorAll('[data-adjust-form]').forEach(function (f) { f.hidden = true; });
      playerEl.querySelectorAll('[data-adjust-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      setBusy(false);
      manageHint(demoId);
      announce('De aangepaste versie staat klaar. Beluister en kies opnieuw.');
    }
    function startCoverPoll(demoId) {
      if (coverStop) coverStop();
      coverStop = pollDemo(demoId, {
        initialDelay: 6000, // wacht tot de cover-demo in de database staat
        interval: 5000,
        graceMs: 36000,
        maxMs: 240000,
        onUpdate: function (data) { if (data && data.has_songs) coverReady(demoId, data); },
        onDone: function (data) { coverReady(demoId, data); },
        onFail: function () { coverPending = false; setBusy(false); announce('Het aanpassen is niet gelukt. Probeer het opnieuw.'); },
        onTimeout: function () { coverPending = false; setBusy(false); announce('Het aanpassen duurt langer dan verwacht. We sturen je de aangepaste versie per e-mail.'); }
      });
    }
    function doCover(songIndex, correction) {
      var origDemo = state.demo_id || config.testDemoId;
      if (!origDemo) { announce('Er is geen demo om aan te passen.'); return; }
      coverPending = true;
      setBusy(true);
      var names = (state.recipients || []).filter(function (r) { return r.name; })
        .map(function (r) { return { name: r.name, phonetic: r.phonetic || '' }; });
      var body = {
        _cfg: 'v2',
        email: state.email || '',
        names: names,
        recipient: state.recipient || (names[0] && names[0].name) || '',
        occasion: state.occasion || 'Afscheid',
        songtext: state.songtext || '',
        story: state.story || '',
        musicStyle: state.musicStyle || 'rustig akoestisch',
        mood: state.mood || 'ingetogen en warm',
        voice_type: state.voice_type || '',
        extra_wishes: state.extra_wishes || '',
        cover: true,
        original_demo_id: origDemo,
        original_song_index: songIndex,
        pronunciation_correction: correction
      };
      api('/demo-generate', { method: 'POST', body: body }).then(function (res) {
        if (res && res.success && res.demo_id) {
          setState({ demo_id: res.demo_id, task_id: res.task_id || '', demoCompleted: false, song_index: null, audioUrls: [] });
          saveResume();
          startCoverPoll(res.demo_id);
        } else { throw new Error('geen demo_id'); }
      }).catch(function () {
        coverPending = false;
        setBusy(false);
        announce('Het aanpassen lukte niet. Probeer het opnieuw.');
      });
    }
    playerEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-player-back]')) {
        e.preventDefault();
        if (window.confirm('Weet u het zeker? De huidige demo gaat verloren — uw ingevulde gegevens (naam, sfeer, verhaal, songtekst, e-mail) blijven bewaard.')) {
          // Alleen de demo wissen; de rest van de invoer blijft staan.
          setState({ demo_id: '', task_id: '', song_index: null, demoCompleted: false, audioUrls: [], _demoSig: '', _resumed: false });
          goToKey('email');
        }
        return;
      }
      var tog = e.target.closest('[data-adjust-toggle]');
      var sub = e.target.closest('[data-adjust-submit]');
      if (tog) {
        e.preventDefault();
        var i = tog.getAttribute('data-adjust-toggle');
        var form = playerEl.querySelector('[data-adjust-form="' + i + '"]');
        if (form) {
          form.hidden = !form.hidden;
          tog.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
          if (!form.hidden) { var inp = form.querySelector('[data-adjust-input]'); if (inp) inp.focus(); }
        }
      } else if (sub) {
        e.preventDefault();
        var j = sub.getAttribute('data-adjust-submit');
        var input = playerEl.querySelector('[data-adjust-input="' + j + '"]');
        var val = input ? input.value.trim() : '';
        if (!val) { announce('Beschrijf eerst hoe de naam of woorden moeten klinken.'); if (input) input.focus(); return; }
        doCover(parseInt(j, 10), val);
      }
    });

    // Keuze via radio
    root.addEventListener('change', function (e) {
      var r = e.target.closest('[data-song-radio]');
      if (!r) return;
      var idx = parseInt(r.value, 10);
      setState({ song_index: idx });
      markChosen(idx);
      updateNextEnabled();
      announce('Versie ' + (idx + 1) + ' gekozen.');
    });

    handlers.player = {
      onEnter: function () {
        // In productie komt demo_id uit stap 6; voor het testen valt
        // hij terug op de test-demo uit de sectie-instellingen.
        var demoId = state.demo_id || config.testDemoId;
        var nameEl = playerEl.querySelector('[data-player-name]');
        var name = (state.recipients && state.recipients[0] && state.recipients[0].name) || '';
        if (nameEl) nameEl.textContent = name ? (' voor ' + name) : '';

        var note = playerEl.querySelector('[data-player-note]');
        var a0 = playerEl.querySelector('[data-audio="0"]');
        var a1 = playerEl.querySelector('[data-audio="1"]');

        if (demoId) {
          var w0 = songSrc(0), w1 = songSrc(1);
          if (a0 && w0 && a0.getAttribute('src') !== w0) { a0.src = w0; }
          if (a1 && w1 && a1.getAttribute('src') !== w1) { a1.src = w1; }
          if (note) note.hidden = true;
          wireSinglePlayback();
          manageHint(demoId);
        } else if (note) {
          note.hidden = false;
        }

        // Demo-code tonen (waarmee de klant later kan hervatten)
        var dc = playerEl.querySelector('[data-player-democode]');
        var dcv = playerEl.querySelector('[data-player-democode-value]');
        if (dcv) dcv.textContent = demoId || '';
        if (dc) dc.hidden = !demoId;
        updateHelpLink();

        // Herstel een eerder gemaakte keuze
        if (state.song_index === 0 || state.song_index === 1) {
          var prev = playerEl.querySelector('[data-song-radio][value="' + state.song_index + '"]');
          if (prev) prev.checked = true;
          markChosen(state.song_index);
        }
        updateNextEnabled();
      },
      onLeave: function () {
        if (hintStop) { hintStop(); hintStop = null; }
        if (coverStop) { coverStop(); coverStop = null; }
        // Audio stoppen zodra je de stap verlaat (niet doorspelen)
        playerEl.querySelectorAll('[data-audio]').forEach(function (a) { try { a.pause(); } catch (e) {} });
      },
      validate: function () {
        if (state.song_index === 0 || state.song_index === 1) return true;
        return 'Kies eerst een versie om verder te gaan.';
      }
    };
  })();

  // ══ Stappen 8–10 — pakket, extra's, overzicht ════════════════
  (function registerCheckoutSteps() {
    var PACKAGE_NAMES = { digitaal: 'Digitaal', compleet: 'Compleet', familie: 'Familie' };
    var MOOD_LABELS = { ingetogen: 'Ingetogen', hoopvol: 'Hoopvol', klassiek: 'Klassiek', persoonlijk: 'Persoonlijk' };

    function parsePrice(s) {
      var f = parseFloat(String(s || '').replace(/[^\d,.-]/g, '').replace(',', '.'));
      return isNaN(f) ? 0 : f;
    }
    function formatEUR(n) {
      return '€' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    var usbPrice = parsePrice(config.usbPrice);

    // ── Stap 8 — Pakket ──
    var packageStep = root.querySelector('[data-wizard-step="package"]');
    if (packageStep) {
      packageStep.addEventListener('change', function (e) {
        var r = e.target.closest('[data-package-radio]');
        if (!r) return;
        var card = r.closest('[data-package-card]');
        setState({ package: r.value, packagePrice: parsePrice(card && card.getAttribute('data-price')) });
        packageStep.querySelectorAll('[data-package-card]').forEach(function (c) {
          c.classList.toggle('is-chosen', c === card);
        });
      });
    }
    handlers.package = {
      onEnter: function () {
        if (!state.package) return;
        var r = packageStep.querySelector('[data-package-radio][value="' + state.package + '"]');
        if (!r) return;
        r.checked = true;
        var card = r.closest('[data-package-card]');
        if (card) {
          card.classList.add('is-chosen');
          if (!state.packagePrice) setState({ packagePrice: parsePrice(card.getAttribute('data-price')) });
        }
      },
      validate: function () {
        return state.package ? true : 'Kies een pakket om verder te gaan.';
      }
    };

    // ── Stap 9 — Extra USB's ──
    var addonStep = root.querySelector('[data-wizard-step="addons"]');
    function renderUsb() {
      if (!addonStep) return;
      var out = addonStep.querySelector('[data-usb-count]');
      var sub = addonStep.querySelector('[data-usb-sub]');
      var n = state.usbCount || 0;
      if (out) out.textContent = n;
      if (sub) sub.textContent = n > 0
        ? (n + ' × ' + formatEUR(usbPrice) + ' = ' + formatEUR(n * usbPrice))
        : 'Geen extra USB-sticks.';
    }
    if (addonStep) {
      addonStep.addEventListener('click', function (e) {
        if (e.target.closest('[data-usb-inc]')) { setState({ usbCount: (state.usbCount || 0) + 1 }); renderUsb(); }
        else if (e.target.closest('[data-usb-dec]')) { setState({ usbCount: Math.max(0, (state.usbCount || 0) - 1) }); renderUsb(); }
      });
    }
    handlers.addons = { onEnter: renderUsb };

    // ── Stap: Video-stijl (thema) ──
    var themaStep = root.querySelector('[data-wizard-step="thema"]');
    if (themaStep) {
      themaStep.addEventListener('change', function (e) {
        var r = e.target.closest('[data-thema-radio]');
        if (r) setState({ video_thema: r.value });
      });
    }
    handlers.thema = {
      onEnter: function () {
        var r = themaStep.querySelector('[data-thema-radio][value="' + (state.video_thema || 'normaal') + '"]');
        if (r) r.checked = true;
      }
    };

    // ── Stap 10 — Overzicht ──
    var summaryStep = root.querySelector('[data-wizard-step="summary"]');
    function row(term, val) {
      return '<div class="av-wiz__summary-row"><dt>' + term + '</dt><dd>' + val + '</dd></div>';
    }
    function buildSummary() {
      var names = (state.recipients || []).map(function (r) { return r.name; }).filter(Boolean).join(', ');
      var sfeer = MOOD_LABELS[state.moodKey] || '';
      if (state.extra_wishes) sfeer = sfeer ? (sfeer + ' — ' + state.extra_wishes) : state.extra_wishes;
      var versie = (state.song_index === 0 || state.song_index === 1) ? ('Versie ' + (state.song_index + 1)) : '—';
      var pkgPrice = state.packagePrice || 0;
      var usbN = state.usbCount || 0;
      var html = '';
      html += row('Voor wie', esc(names || '—'));
      if (sfeer) html += row('Sfeer', esc(sfeer));
      html += row('Gekozen versie', esc(versie));
      html += row('Pakket', esc(PACKAGE_NAMES[state.package] || '—') + (pkgPrice ? ' · ' + formatEUR(pkgPrice) : ''));
      if (usbN > 0) html += row('Extra USB-sticks', usbN + ' × ' + formatEUR(usbPrice));
      var dl = summaryStep.querySelector('[data-summary]');
      if (dl) dl.innerHTML = html;

      var totalEl = summaryStep.querySelector('[data-summary-total]');
      if (totalEl) totalEl.textContent = formatEUR(pkgPrice + usbN * usbPrice);

      var pw = summaryStep.querySelector('[data-summary-player]');
      var au = summaryStep.querySelector('[data-summary-audio]');
      if (au && (state.song_index === 0 || state.song_index === 1)) {
        var want = songSrc(state.song_index);
        if (want && au.getAttribute('src') !== want) au.src = want;
        if (pw) pw.hidden = !want;
      } else if (pw) {
        pw.hidden = true;
      }
    }
    function updateCheckoutEnabled() {
      var btn = summaryStep.querySelector('[data-wizard-checkout]');
      if (btn) btn.disabled = !state.termsAccepted;
    }
    if (summaryStep) {
      var tl = summaryStep.querySelector('[data-terms-link]');
      if (tl && config.termsUrl) tl.setAttribute('href', config.termsUrl);
      summaryStep.addEventListener('change', function (e) {
        if (e.target.matches('[data-terms]')) { setState({ termsAccepted: e.target.checked }); updateCheckoutEnabled(); }
      });
    }
    handlers.summary = {
      onEnter: function () {
        buildSummary();
        var t = summaryStep.querySelector('[data-terms]');
        if (t) t.checked = !!state.termsAccepted;
        // Hulplink naar contact met demo-code + e-mail voorgevuld
        var hl = summaryStep.querySelector('[data-summary-help]');
        if (hl) {
          var qs = [];
          if (state.demo_id) qs.push('demo_id=' + encodeURIComponent(state.demo_id));
          if (state.email) qs.push('email=' + encodeURIComponent(state.email));
          hl.href = '/pages/contact' + (qs.length ? '?' + qs.join('&') : '');
        }
        updateCheckoutEnabled();
      },
      onLeave: function () {
        var au = summaryStep.querySelector('[data-summary-audio]');
        if (au) { try { au.pause(); } catch (e) {} }
      }
    };
  })();

  // ══ Resume-flow (§6) ══════════════════════════════════════════
  function getParam(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }
  function setResumeView(on) {
    var resumeEl = root.querySelector('[data-wizard-resume]');
    var stepsEl = root.querySelector('.av-wiz__steps');
    var progEl = root.querySelector('[data-wizard-progress]');
    if (resumeEl) resumeEl.hidden = !on;
    if (stepsEl) stepsEl.hidden = on;
    if (progEl) progEl.hidden = on;
  }
  function showResumeError(msg) {
    var loadEl = root.querySelector('[data-resume-loading]');
    var errEl = root.querySelector('[data-resume-error]');
    var txt = root.querySelector('[data-resume-error-text]');
    if (txt) txt.textContent = msg;
    if (loadEl) loadEl.hidden = true;
    if (errEl) errEl.hidden = false;
  }
  function attemptResume(demoId, email) {
    setResumeView(true);
    api('/demo-resume', { method: 'POST', body: { demo_id: demoId, email: email } }).then(function (res) {
      // Let op: alles zit onder res.data — status is data.status, NIET res.status.
      var data = (res && res.data) || {};
      if (res && res.success) {
        var patch = {
          demo_id: data.demo_id || demoId,
          email: data.email || email,
          _resumed: true,
          demoCompleted: data.status === 'completed'
        };
        if (data.recipients && data.recipients.length) {
          patch.recipients = data.recipients;
          patch.recipient = data.recipients[0].name || '';
        }
        if (data.mood) patch.mood = data.mood;
        if (data.lyrics) patch.songtext = data.lyrics;
        if (data.occasion) patch.occasion = data.occasion;
        if (data.voice_type) patch.voice_type = data.voice_type;
        // Directe audio-URL's (0-geïndexeerd), met stream-URL als terugval.
        patch.audioUrls = [
          data.song_0_audio_url || data.song_0_stream_url || '',
          data.song_1_audio_url || data.song_1_stream_url || ''
        ];
        setState(patch);
        saveResume();
        if (history.replaceState) history.replaceState({}, '', location.pathname); // query opschonen
        setResumeView(false);
        goToKey('player'); // demo is beschikbaar → direct naar de speler
      } else {
        var code = res && res.error;
        var msg = (res && res.message) || (code === 'demo_pending'
          ? 'De demo wordt nog aangemaakt. Probeer het over enkele minuten opnieuw.'
          : 'We konden je demo niet vinden. Controleer je link of maak een nieuw liedje.');
        showResumeError(msg);
      }
    }).catch(function () {
      showResumeError('Er ging iets mis bij het ophalen. Probeer het later opnieuw.');
    });
  }

  // ── Init ──────────────────────────────────────────────────────
  var qDemo = getParam('demo_id'), qEmail = getParam('email');
  if (qDemo && qEmail) {
    attemptResume(qDemo, qEmail);
  } else {
    // Naam meegegeven vanaf de landingspagina → stap 1 (Voor wie) voorvullen
    var qNaam = getParam('naam');
    if (qNaam) {
      setState({ recipients: [{ name: qNaam, phonetic: '' }], recipient: qNaam });
      if (history.replaceState) history.replaceState({}, '', location.pathname); // naam uit URL opschonen
    }
    showStep(index, { silent: true });
  }
})();
